<template>
      <v-carousel :cycle="false" :height="450" @change="onSlideChange">
      <v-carousel-item
        v-for="item in attachments"
        :key="item.asset.id"
      ><v-hover>
                <v-card slot-scope="{ hover }" class="mx-auto" color="black" height="450">
                  <v-btn flat icon :href="item.asset.url" target="_blank" class="text-xs-right open-in-new-button">
                    <v-icon small color="white">open_in_new</v-icon>
                  </v-btn>
                  <v-layout align-center justify-center fill-height>
                    <v-flex>
              <v-img
                v-if="isImage(item.asset.fileType)"
                :src="item.asset.url"
                contain
                max-height="450">
              </v-img>
              <video
                ref="mediaPlayers"
                v-else-if="isVideo(item.asset.fileType)"
                :src="item.asset.url"
                controls
                controlsList="nodownload"
                style="width: 100%; height: 380px; max-height: 380px; margin-bottom: 100px; object-fit: contain; outline: none; background-color: black;">
              </video>
            </v-flex>
                  </v-layout>
                  <v-expand-transition>
                    <div v-if="hover" class="transition-fast-in-fast-out grey darken-2 v-card--reveal white--text pa-3"
                         :style="`height: ${getHoverHeight(item)}%;`">
                      <strong>Descripción: </strong>
                      <span>{{ item.asset.description || '-' }}</span>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-hover>
      </v-carousel-item>
    </v-carousel>
</template>
<script>
const MIN_HOVER_HEIGHT = 29
const LINE_HEIGHT = 7
const MAX_LENGTH_PER_LINE = 150

export default {
  props: {
    attachments: Array
  },
  data () {
    return {
    }
  },
  methods: {
    getHoverHeight (item) {
      let length = (item.asset.description) ? item.asset.description.length : 0
      return (length / MAX_LENGTH_PER_LINE) * LINE_HEIGHT + MIN_HOVER_HEIGHT
    },
    isImage (fileType) {
      return fileType && fileType.match('image.*')
    },
    isVideo (fileType) {
      return fileType && fileType.match('video.*')
    },
    onSlideChange () {
      if (this.$refs.mediaPlayers) {
        this.$refs.mediaPlayers.forEach(video => {
          if (!video.paused) {
            video.pause()
          }
        })
      }
    }
  },
  created () {
  }
}
</script>
